import bop1 from "@/assets/gallery/BOPHOISTSLOADTESTING/Bop1.jpg";
import bop2 from "@/assets/gallery/BOPHOISTSLOADTESTING/Bop2.jpg";
/* import bop3 from "@/assets/gallery/BOPHOISTSLOADTESTING/Bop3.jpg"; */
import bop4 from "@/assets/gallery/BOPHOISTSLOADTESTING/Bop4.jpg";

/* CROWN BLOCK */
import block1 from "@/assets/gallery/CROWNBLOCK/block1.jpg";
import block2 from "@/assets/gallery/CROWNBLOCK/block2.jpg";
import block3 from "@/assets/gallery/CROWNBLOCK/block3.jpg";
import block4 from "@/assets/gallery/CROWNBLOCK/block4.jpg";
import block5 from "@/assets/gallery/CROWNBLOCK/block5.jpg";
import block6 from "@/assets/gallery/CROWNBLOCK/block6.jpg";
import block7 from "@/assets/gallery/CROWNBLOCK/block7.jpg";
import block8 from "@/assets/gallery/CROWNBLOCK/block8.jpg";
import block9 from "@/assets/gallery/CROWNBLOCK/block9.jpg";
import block10 from "@/assets/gallery/CROWNBLOCK/block10.jpg";

/* PULSATION DUMPNER */
import dum1 from "@/assets/gallery/PULSATIONDUMPNER/dum1.jpg";
import dum2 from "@/assets/gallery/PULSATIONDUMPNER/dum2.jpg";
import dum3 from "@/assets/gallery/PULSATIONDUMPNER/dum3.jpg";
import dum4 from "@/assets/gallery/PULSATIONDUMPNER/dum4.jpg";

/* FORK LIFT TRUCK */
import for1 from "@/assets/gallery/FORKLIFTTRUCK/for1.jpg";
import for2 from "@/assets/gallery/FORKLIFTTRUCK/for2.jpg";
import for3 from "@/assets/gallery/FORKLIFTTRUCK/for3.jpg";

/* TDS */
import TDS1 from "@/assets/gallery/TDS/TDS1.jpg";
import TDS2 from "@/assets/gallery/TDS/TDS2.jpg";

/* SKIDS AND BASKETS INSPECTION */
import SKI1 from "@/assets/gallery/SKIDSANDBASKETSINSPECTION/SKI1.jpg";
import SKI2 from "@/assets/gallery/SKIDSANDBASKETSINSPECTION/SKI2.jpg";
import SKI3 from "@/assets/gallery/SKIDSANDBASKETSINSPECTION/SKI3.jpg";
import SKI4 from "@/assets/gallery/SKIDSANDBASKETSINSPECTION/SKI4.jpg";
import SKI5 from "@/assets/gallery/SKIDSANDBASKETSINSPECTION/SKI5.jpg";

/* FIFTH WHEEL */
import Fith1 from "@/assets/gallery/FIFTHWHEEL/Fith1.jpg";
import Fith2 from "@/assets/gallery/FIFTHWHEEL/Fith2.jpg";

/* PAD EYES LOAD TESTING */
import PA1 from "@/assets/gallery/PADEYESLOADTESTING/PA1.jpg";
import PA2 from "@/assets/gallery/PADEYESLOADTESTING/PA2.jpg";
import PA3 from "@/assets/gallery/PADEYESLOADTESTING/PA3.jpg";
import PA4 from "@/assets/gallery/PADEYESLOADTESTING/PA4.jpg";







export type GalleryCategory = {
  id: string;
  label: string;
  title: string;
  tagline: string;
  images: string[];
};

export const GALLERY_CATEGORIES: GalleryCategory[] = [


  /* //our real gallary */
  {
    id: "BOP HOISTS",
    label: "BOP HOISTS LOAD TESTING",
    title: "BOP HOISTS LOAD TESTING",
    tagline: "",
    images: [bop1, bop2, bop4],
  },


  {
    id: "CROWN BLOCK",
    label: "CROWN BLOCK",
    title: "CROWN BLOCK",
    tagline: "",
    images: [block1, block2, block3, block4, block5, block6, block7, block8, block9, block10],
  },

  {
    id: "PULSATION DUMPNER",
    label: "PULSATION DUMPNER",
    title: "PULSATION DUMPNER",
    tagline: "",
    images: [dum1, dum2, dum3, dum4],
  },
  {
    id: "FORK LIFT TRUCK",
    label: "FORK LIFT TRUCK",
    title: "FORK LIFT TRUCK",
    tagline: "",
    images: [for1, for2, for3],
  },

  {
    id: "TDS",
    label: "TDS",
    title: "TDS",
    tagline: "",
    images: [TDS1, TDS2],
  },


  {
    id: "SKIDS AND BASKETS INSPECTION",
    label: "SKIDS AND BASKETS INSPECTION",
    title: "SKIDS AND BASKETS INSPECTION",
    tagline: "",
    images: [SKI1, SKI2, SKI3, SKI4, SKI5],
  },

  {
    id: "FIFTH WHEEL",
    label: "FIFTH WHEEL",
    title: "FIFTH WHEEL",
    tagline: "",
    images: [Fith1, Fith2],
  },

  {
    id: "PAD EYES LOAD TESTING",
    label: "PAD EYES LOAD TESTING",
    title: "PAD EYES LOAD TESTING",
    tagline: "",
    images: [PA1, PA2, PA3, PA4],
  },
];
